<div [ngStyle]="backgroundStyle"  class="modal-header">
    <h4 style="color: white;" class="modal-title pull-left">View Shipment</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div> 


  
    <div class="modal-body">
    <div class="card">
      <div class="card-body">
        
        <form >  
            

    <div class="form-group row">
        <div class="col-md-6">
        <label  for="shipmentAddress">Address</label>
        <input readonly  class="form-control" type="text" name="shipmentAddress" id="shipmentAddress" [(ngModel)]="shipment.shipmentAddress">
        </div>

        <div class="col-md-6">
        <label  for="shipmentPartner">Shipment Partner</label>
        <input readonly  class="form-control" type="text" name="shipmentPartner" id="shipmentPartner" [(ngModel)]="shipment.shipmentPartner">
    
        </div>
    </div>

  

    <div class="form-group row">
        <div class="col-md-4">
        <label class="required"  for="shippedDate">Shipped Date</label>
        <input #date="ngModel" required class="form-control" type="datetime-local" name="shippedDate" id="shippedDate" [(ngModel)]="shipment.shippedDateTime">
        <div class="alert alert-danger" *ngIf="date.touched && !date.valid">Provice Shipped Date</div>
    </div>

    <div class="col-md-4">
        <label for="expectedDeliveryDateTime">Expected Delivery Date</label>
        <input class="form-control" [(ngModel)]="shipment.expectedDeliveryDateTime" type="datetime-local" id="expectedDeliveryDateTime" name="expectedDeliveryDateTime">
    </div>

    <div class="col-md-4">
        <label  for="deliveryDateTime">Delivery Date</label>
        <input class="form-control" type="datetime-local" name="deliveryDateTime" id="deliveryDateTime" [(ngModel)]="shipment.deliveryDateTime">
    </div>
    </div>

    <div >
        <label  for="shipmentRemarks">Shipment Remarks</label>
        <textarea readonly  class="form-control" type="text" name="shipmentRemarks" id="shipmentRemarks" [(ngModel)]="shipment.shipmentRemarks"></textarea>
    </div>

    <br>

    <div>
        <label  for="deliveryRemarks">Delivery Remarks</label>
        <textarea readonly maxlength="244" class="form-control" type="text" name="deliveryRemarks" id="deliveryRemarks" [(ngModel)]="shipment.deliveryRemarks"></textarea>
    </div>

   

</form>
</div>
    </div>
    </div>

  
    

	